<h1 mat-dialog-title>
  {{ title }}
</h1>

<div mat-dialog-content>
  <p>{{ message }}</p>
</div>

<div mat-dialog-actions class="flex justify-between">
  <button mat-button (click)="onDismiss()">{{ dismissButton }}</button>
  <button mat-raised-button color="error" (click)="onConfirm()">
    {{ confirmButton }}
  </button>
</div>
